import { render, staticRenderFns } from "./ApplicationPackag_new.vue?vue&type=template&id=4827ffa4&scoped=true&"
import script from "./ApplicationPackag_new.vue?vue&type=script&lang=js&"
export * from "./ApplicationPackag_new.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationPackag_new.vue?vue&type=style&index=0&id=4827ffa4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4827ffa4",
  null
  
)

export default component.exports